import React from "react";
import { Zap, CheckCircle2 } from "lucide-react";

/**
 * NO EXCUSES MODE banner — placed at the top of every field form.
 * Communicates to the viewer that key fields are auto-filled from the
 * system (Job, Equipment, Sub/Vendor, Location/GPS, Weather) so they
 * never have to type what the platform already knows.
 *
 * Pure visual — does NOT touch form state. Accepts an optional `items`
 * prop to override the default chip list.
 */
export default function NoExcusesBanner({ items, className = "" }) {
  const DEFAULTS = [
    "Job · prefilled",
    "Equipment · prefilled",
    "Sub / Vendor · prefilled",
    "Location · GPS auto",
    "Weather · auto",
    "PM · auto-routed",
  ];
  const chips = items && items.length ? items : DEFAULTS;
  return (
    <div
      data-testid="no-excuses-banner"
      className={`mb-6 rounded-xl border-2 overflow-hidden ${className}`}
      style={{
        background:
          "linear-gradient(90deg, rgba(255,106,0,0.14), rgba(255,106,0,0.04))",
        borderColor: "rgba(255,106,0,0.45)",
      }}
    >
      <div className="flex items-center gap-3 px-4 sm:px-5 py-3">
        <span
          className="inline-flex items-center justify-center w-9 h-9 rounded-md shrink-0"
          style={{ background: "#FF6A00", color: "#000" }}
        >
          <Zap className="w-5 h-5" />
        </span>
        <div className="min-w-0 flex-1">
          <div
            className="font-mono text-[10px] uppercase tracking-[0.3em]"
            style={{ color: "#FF6A00" }}
          >
            No Excuses Mode · Auto-fill active
          </div>
          <div className="text-white font-bold text-sm leading-snug">
            ForgedOps pre-fills everything the system already knows. No typing
            what's obvious.
          </div>
        </div>
      </div>
      <div
        className="px-4 sm:px-5 py-2 border-t flex flex-wrap gap-1.5"
        style={{
          borderColor: "rgba(255,106,0,0.25)",
          background: "rgba(0,0,0,0.2)",
        }}
      >
        {chips.map((c) => (
          <span
            key={c}
            className="inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.15em] px-2 py-1 rounded"
            style={{
              color: "#FFFFFF",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
            }}
          >
            <CheckCircle2 className="w-3 h-3" style={{ color: "#FF6A00" }} />
            {c}
          </span>
        ))}
      </div>
    </div>
  );
}
